import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Localised duration ("24 hours", "3 Tage") from a number of hours.
export function durationLabel(hours, lang = "fr") {
  const h = Number(hours) || 0;
  const [n, unit] = h < 48 ? [h, "hour"] : [Math.round(h / 24), "day"];
  try { return new Intl.NumberFormat(lang, { style: "unit", unit, unitDisplay: "long" }).format(n); }
  catch { return `${n} ${unit === "hour" ? "h" : "j"}`; }
}
